import { ErrorLogComponent } from '@cian/error-log-component';

import { type FC } from 'react';

import { ContentLayout } from '@/microfrontends/listing/shared/containers/listing-cards/components/desktop/ContentLayout';
import { AddressBlockContainer } from '@/microfrontends/listing/shared/containers/listing-cards/containers/common/AddressBlockContainer';
import { SpecialGeoListContainer } from '@/microfrontends/listing/shared/containers/listing-cards/containers/common/SpecialGeoListContainer';
import { CardPriceBlockContainer } from '@/microfrontends/listing/shared/containers/listing-cards/containers/desktop/CardPriceBlock';
import { FactoidsContainer } from '@/microfrontends/listing/shared/containers/listing-cards/containers/desktop/Factoids';
import { PublisherLabelsContainer } from '@/microfrontends/listing/shared/containers/listing-cards/containers/desktop/PublisherLabels';
import { SubtitleContainer } from '@/microfrontends/listing/shared/containers/listing-cards/containers/desktop/Subtitle';
import { TitleContainer } from '@/microfrontends/listing/shared/containers/listing-cards/containers/desktop/Title';
import { useListingAppContext } from '@/microfrontends/listing/shared/context/ListingAppContext';

import { CardDescriptionContainer } from '../CardDescriptionContainer';

export const CardContentContainer: FC = () => {
  const { logger } = useListingAppContext();

  return (
    <ErrorLogComponent level="error" logger={logger}>
      <ContentLayout>
        <ContentLayout.BlockL>
          <ContentLayout.BlockS as="section">
            <TitleContainer />
            <SubtitleContainer />
            <FactoidsContainer />
          </ContentLayout.BlockS>

          <PublisherLabelsContainer />

          <ContentLayout.BlockS as="section">
            <SpecialGeoListContainer />
            <AddressBlockContainer />
          </ContentLayout.BlockS>

          <CardPriceBlockContainer />
        </ContentLayout.BlockL>

        <ContentLayout.Footer>
          <CardDescriptionContainer />
        </ContentLayout.Footer>
      </ContentLayout>
    </ErrorLogComponent>
  );
};
